import Vue from "vue";
import App from "./App.vue";
import firebase from "firebase";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueTheMask from "vue-the-mask";
import CKEditor from "ckeditor4-vue";

import VueLodash from "vue-lodash";
import lodash from "lodash";
Vue.use(VueLodash, { name: "custom", lodash: lodash });

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

//EHC-IFY
import ehcPage from "@/components/global/ehc-page.vue";
import ehcForm from "@/components/global/ehc-form/ehc-form.vue";
import ehcDialog from "@/components/global/ehc-dialog.vue";
import ehcDrawer from "@/components/ehc-drawer.vue";
import ehcButton from "@/components/global/ehc-btn.vue";
import ehcTable from "@/components/global/ehc-table.vue";
import ehcShowObj from "@/components/global/ehc-show-obj.vue";
import ehcSheet from "@/components/global/ehc-sheet.vue";
import ehcHeader from "@/components/global/ehc-header.vue";
import ehcCard from "@/components/global/ehc-card.vue";
import ehcLoadingOverlay from "@/components/global/ehc-loading-overlay.vue";
import ehcContextMenu from "@/components/global/ehc-context-menu.vue";
import ehcMenu from "@/components/global/ehc-menu.vue";
import ehcMessage from "@/components/global/ehc-message.vue";

Vue.component("ehc-loading-overlay", ehcLoadingOverlay);
Vue.component("ehc-message", ehcMessage);
Vue.component("ehc-card", ehcCard);
Vue.component("ehc-header", ehcHeader);
Vue.component("ehc-sheet", ehcSheet);
Vue.component("ehc-show-obj", ehcShowObj);
Vue.component("ehc-table", ehcTable);
Vue.component("ehc-page", ehcPage);
Vue.component("ehc-form", ehcForm);
Vue.component("ehc-dialog", ehcDialog);
Vue.component("ehc-drawer", ehcDrawer);
Vue.component("ehc-btn", ehcButton);
Vue.component("ehc-context-menu", ehcContextMenu);
Vue.component("ehc-menu", ehcMenu);

import apiMixin from "@/mixins/api.vue";
import globalComputedValues from "@/mixins/globalComputedValues.vue";
import authMixin from "@/mixins/auth.vue";
import indexMixin from "@/mixins/index.vue";

Vue.mixin(apiMixin);
Vue.mixin(authMixin);
Vue.mixin(globalComputedValues);
Vue.mixin(indexMixin);

Vue.use(VueTheMask);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
}

Vue.use(CKEditor);

const firebaseConfig = {
  apiKey: "AIzaSyDxy33ykhdYbBOTXLJx128jlxWHB5KmrQY",
  authDomain: "everhostio.firebaseapp.com",
  databaseURL: "https://everhostio-default-rtdb.firebaseio.com",
  projectId: "everhostio",
  storageBucket: "everhostio.appspot.com",
  messagingSenderId: "355449850402",
  appId: "1:355449850402:web:4ee9935f1cb5e947b1587b",
  measurementId: "G-ZLJS89XE0W",
};

const firebaseConfigDev = {
  apiKey: "AIzaSyDxy33ykhdYbBOTXLJx128jlxWHB5KmrQY",
  authDomain: "dev-everhostio.firebaseapp.com",
  projectId: "dev-everhostio",
  storageBucket: "dev-everhostio.appspot.com",
  messagingSenderId: "333205235104",
  appId: "1:333205235104:web:b2e0a905dc7ecc929570c5",
};

firebase.initializeApp(firebaseConfig);

// Networks that block Firestore WebChannel streaming leave org lookups hanging;
// auto-detect long polling recovers on CI runners and restrictive networks.
firebase.firestore().settings({
  experimentalAutoDetectLongPolling: true,
  merge: true,
});

const analytics = firebase.analytics();

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
});

app.$mount("#app");
